import { faBuilding } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { CardWithIcon, CardListItem, CardContentBox } from "./CardElements"
import {
    AdminAdministratorFor,
    AdminAdministratorForCompany,
    AdminAdministratorForUserGroup,
} from "../../users/userTypes"
import { useAppLocalization } from "../../localization/components/AppLocalizationProvider"
import { UserType } from "../../login/loginTypes"

type AdministratorForCardProps = {
    list: AdminAdministratorFor
    type: UserType
    isWithIcon?: boolean
    hostedByKey?: "userGroup" | "company"
}

function isCompany(
    entity: AdminAdministratorForUserGroup | AdminAdministratorForCompany | undefined,
): entity is AdminAdministratorForCompany {
    return !!entity && (entity as AdminAdministratorForCompany).isOfficeHotel !== undefined
}

export const AdministratorForCard = ({ list, type, isWithIcon = false, hostedByKey }: AdministratorForCardProps) => {
    const { l10n } = useAppLocalization()

    const entity = hostedByKey && hostedByKey in list ? list[hostedByKey] : list.userGroup

    if (!entity) {
        // Render some placeholder or message indicating that no data is available
        return null
    }

    const content = (
        <>
            <CardListItem
                title={
                    <LocalizedStrict id="profile-user-account-id">
                        <>ID:</>
                    </LocalizedStrict>
                }
                content={entity.id}
                isOneLineContent={!isWithIcon}
            />
            <CardListItem
                title={
                    <LocalizedStrict id="profile-name">
                        <>Name:</>
                    </LocalizedStrict>
                }
                content={entity.name}
                chipTitle={
                    isCompany(entity)
                        ? l10n.getString("profile-hosted-by-office-hotel")
                        : l10n.getStringForEnum("profile-usertype", type, type)
                }
                isOneLineContent={!isWithIcon}
            />
        </>
    )

    if (isWithIcon) {
        return (
            <CardWithIcon
                icon={faBuilding}
                iconSize="6x"
                title={
                    <LocalizedStrict id="profile-administrator-for">
                        <>Administrator for</>
                    </LocalizedStrict>
                }
            >
                {content}
            </CardWithIcon>
        )
    } else {
        return (
            <CardContentBox
                title={
                    <LocalizedStrict id={hostedByKey ? "profile-hosted-by" : "profile-administrator-for"}>
                        <>{hostedByKey ? "Hosted by" : "Administrator for"}</>
                    </LocalizedStrict>
                }
            >
                {content}
            </CardContentBox>
        )
    }
}
